<template>
  <div class=" pb-3">
    <v-row class="mx-2">
      <v-col
        cols="12"
        md="4"
        class="flex-wrap"
        v-for="item in teacher"
        :key="item.id"
      >
        <v-card rounded="lg" class="text-center">
          <v-card-title
            class="custom__header pa-2 d-flex align-center justify-center"
          >
            {{ item.name }}
          </v-card-title>
          <v-card-text class="mt-2">
            <div>
              <v-avatar size="120">
                <img src="../assets/captain.jpeg" alt="" />
              </v-avatar>
            </div>

            <div class="my-2">
              <span class="font-weight-bold text-h5">Accounting</span>
            </div>
            <div class="my-2">
              <span class="font-weight-bold text-h5">jrenvekelkkkrekre</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    
    </v-row>
  </div>
</template>
<script>
export default {
  data: () => ({
    fab: false,
    teacher: [
      {
        id: "1",
        name: "prof. mubarak ibrahim",
      },
      {
        id: "2",
        name: "prof. mubarak ibrahim",
      },
      {
        id: "3",
        name: "prof. mubarak ibrahim",
      },
      {
        id: "4",
        name: "prof. mubarak ibrahim",
      },
    ],
  }),
};
</script>
<style scoped>
.custom__bg {
  background: #f5f5f5;
}
.custom__header {
  background: #f69227;
  color: #ffff;
  text-align: center;
}
.v-btn--example {
  bottom: 0;
  position: relative;
  margin: 0 0 16px 16px;
}
</style>
